import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import * as moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare let swal:any;
import { FormControl,FormBuilder, FormGroup,Validators } from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

import  jspdf from 'jspdf';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $:any;

@Component({
  selector: 'app-stock-level-database',
  templateUrl: './stock-level-database.component.html',
  styleUrls: ['./stock-level-database.component.css']
}) 
export class StockLevelDatabaseComponent implements OnInit {
  
  @ViewChild('table') table: ElementRef;
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  form_id:any;
  cumulativeeadr:any;
  getlistApi:any;
  selectallvalue:any;
  getfarmsListData:any;
  loadspeciesValue:any;
  getspeciesvalue:any;
  addUrl:any;
  speciesloaddata:any;
  getData:any=[]; 
  datatable:boolean=false;
  isLoading:boolean=false;
  getExportData:any=[]; 
  get_age:any;
  ageUrl :any;
  getlistApi1: any;
  opening_bal: number=0;
  closing_total: number=0;
  dict: any=[];
  datagetpercent:any[]= [];
  loop_check:boolean=false;
  constructor(private router: Router,private commonService: CommonService,private formBuilder: FormBuilder) { }
  async ngOnInit(): Promise<void> {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      this.form_id=this.farm_userrole;
    }else{
    this.form_id=null;
    }
    this.isLoading =true;
    var table;
      $('.selectpicker').selectpicker('refresh');
      this.getlistApi=(this.form_id!=null)?'/farms/'+this.form_id:"/farms";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        async(res) => {
          this.getfarmsListData = (this.form_id!=null)?[res.data]:res.data;
          this.getfarmsListData.unshift({tnfr_id:null,tnfr_name:"Select Farm Name"});
          setTimeout(function () {
            // $('#reportrange_date').daterangepicker('refresh');
             $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
          }, 1500);
    })

   $('#farmname').change(async ()=> {
    $("#speciesid").find('option').remove().end();
   // console.log(  $('#farmname').val())
      this.selectallvalue= $('#farmname').val();
      var farmvalue="";
  farmvalue = this.selectallvalue.toString();
  this.loadspeciesValue = {
  "farms_id":farmvalue
  };
  console.log(this.loadspeciesValue.farm_id)
  if(farmvalue!="null"){
        //species load in select dropdown based on farm select api call
        this.addUrl = "/species/farms";
        (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
          res => {
            this.speciesloaddata=res.data;
            this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
            console.log( this.speciesloaddata)
            
          })
    }else{
          $('#Speciesname').val('null');
          this.speciesloaddata=[{id:null,name:"Select Species Name"}];
          $('#BreedName').val('null');
          this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
         $('#age').val('null');
         this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
    }
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 1500);
    });
          
  $(document).on('change', '#farmname', function() {
    $('.myFakeClass').dropdown('toggle');
  });
  $(document).on('change', '#Speciesname', function() {
    $('.myFakeClass1').dropdown('toggle');
  });
  $(document).on('change', '#BreedName', function() {
    $('.myFakeClass2').dropdown('toggle');
  });
  $(document).on('change', '#age', function() {
    $('.myFakeClass3').dropdown('toggle');
  });
  }
  async breedselectbyspecies(event){
    //console.log(event.target.value);
    if(event.target.value!='null'){
    this.addUrl = "/breeds/species/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
           this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
          //console.log(this.getspeciesvalue);
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 1000);
      });
      this.ageUrl="/species/age_group/all_category/?species_id="+event.target.value;
      (await this.commonService.getApi(this.ageUrl)).subscribe(
        res => {
             this.get_age=res.data;
             this.get_age.unshift({tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'});
            //console.log(this.get_age);
            setTimeout(function () {
              $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
           }, 1000);
        });
      }else{
        $('#BreedName').val('null');
        this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
       $('#age').val('null');
       this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
      }
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
  }
  
  date_format(dateObject) {
    var d = new Date(dateObject);
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1 ;
    var month1 ;
    if (day < 10) {
        day1 = "0" + day;
    }else{
       day1 = day;
    }
    if (month < 10) {
        month1 = "0" + month;
    }else{
       month1 =  month;
    }
    var date = year + "-" + month1;
  
    return date;
  };

  async get_datas(){
    this.datatable=true;
    this.isLoading=true;
    $('#myTable').DataTable().clear().destroy();
    var table;
    var from_date = $("input[name='daterangepicker_start']" ).val();
    var to_date = $("input[name='daterangepicker_end']" ).val();
   
    var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
    var species_id=$('#Speciesname').val();
    var breed_id=$('#BreedName').val();
    var age=$('#age').val();

    this.getlistApi="/reports/annual_report/?from_date="+this.date_format(from_date)+"&to_date="+this.date_format(to_date)+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
     (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => { 

       var dateStart = moment(from_date);
       var dateEnd = moment(to_date);
       var timeValues = [];
       while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
          timeValues.push(dateStart.format('YYYY-MM,MMMM'));
          dateStart.add(1,'month');
       }
  
       let result = [];
 
      var arr=[];
       timeValues.forEach(date => {
         var somedate=date.split(',');
         
         arr.push(somedate[0])
         const item = res.data.find(item =>item.date == somedate[0]);

         if (item) {
           result.push(item);
         } else {
          var date_=somedate[0];
          var year_=date_.split('-');
          //console.log('somedate',year_);
           if(result.length<=0){
            
            result.push({date: somedate[0],month:somedate[1], addition_count:0,opening_count:0,animal_days:0,total_count:0,deletion_count:0,current_balance:0,death_count:0,cumulative_stock:0,cumulative_addition:0, cumulative_total_count:0,cumulative_deletion:0,cumulative_animal_days:0,mortality_percentage:0,cumulative_current_balance:0,cumulative_death:0,year:year_[0]});
           }else{
            let lastElement = result[result.length - 1];
            var opencount=lastElement.current_balance;
            var totalcount=opencount;
            var deletioncount=lastElement.deletion_count;
            var currentbalance=totalcount-deletioncount+lastElement.death_count;
            var cumulativestock=lastElement.cumulative_stock;
            var additionsinceseledate=0+lastElement.cumulative_addition;
            var totalsinceselectdate=cumulativestock+additionsinceseledate;
            var cumulativecurrenbal=totalsinceselectdate-0;
            var anidaysnor=lastElement.current_balance;
 
            var cumulativeanidays=lastElement.cumulative_animal_days;
           
            result.push({date: somedate[0],month:somedate[1], addition_count:0,opening_count:opencount,animal_days:anidaysnor,total_count:totalcount,deletion_count:0,current_balance:currentbalance,death_count:0,cumulative_stock:cumulativestock,cumulative_addition:additionsinceseledate, cumulative_total_count:totalsinceselectdate,cumulative_deletion:0,cumulative_animal_days:cumulativeanidays,mortality_percentage:0.00,cumulative_current_balance:cumulativecurrenbal,cumulative_death:0,year:year_[0]});
           }
        
         }
       })

       this.getData=[];
       this.getExportData=[];
        this.dict = [];
        let anima_days=0;
  
       if(result.length>0){
        for (var i = 0; i < result.length; i++) {
   
            this.get_animal_days(result[i].date,i);    
            //console.log(result[i]);
            this.dict.push(result[i]);
    
        } 
      }

        this.getExportData=this.dict;
        this.getData = this.dict;
        var getcallbackval=this.getData;

         setTimeout(() => {
           this.datagetpercent=getcallbackval.map(o =>{
             var percentnormaleadr=(o.death_count/o.ani_days*1000).toFixed(2);
             var percent=(o.cumulative_death/o.ani_cumulative_animal_days*1000).toFixed(2);
    
             return ({...o,cumulative_EADR:percent,Normal_EADR:percentnormaleadr})
              });
         }, 2000);
         
         setTimeout(() => {
          table = $("#myTable").DataTable().draw();
          this.isLoading=false;
        }, 3000);

          }) ;
  
  
    
  }

  show_cum_ani_days=(ind:number)=>{
    //ind=ind-1;
    var ani=0;
    for (var l = 0; l <  this.dict.length; l++) {
      if(l<=ind){
        ani=ani+this.dict[l]['ani_days'];       
      }
   }
   return ani;
  }  


  show_normal_eadr=(ani_days:number,death_cou:number)=>{
    //ind=ind-1;
   // var ani=this.show_cum_ani_days(ind);
    var ret=((death_cou/ani_days)*1000).toFixed(3);
  
 if(isNaN(parseInt(ret))){
   ret='0';
 }
   return ret;
  }  

  show_cum_eadr=(ind:number,death_cou:number)=>{
    //ind=ind-1;
    var ani=this.show_cum_ani_days(ind);
    var ret=((death_cou/ani)*1000).toFixed(3);
    if(isNaN(parseInt(ret))){
      ret='0';
    }
   return ret;
  }


   /* */
  

  arrayColumn(array, columnName) {
    return array.map(function(value,index) {
        return value[columnName];
    })
  }

  async get_animal_days(date,ind){

    var ani_from=date+"-01";
      var ani_to=this.endOfMonth(date);

    var getDaysArray = function(start, end) {
      for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
      var date=new Date(dt);
        var d = date.getDate();
      var m = date.getMonth() + 1;
      var y = date.getFullYear();
  
          arr.push(y+'-' + (m <= 9 ? '0' + m : m)+ '-'+(d <= 9 ? '0' + d : d));
      }
      return arr;
  };


    var from_date = ani_from;
    var to_date = ani_to;
    //var farm_id=($('#farmname').val()==null)?this.form_id:$('#farmname').val();
    var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
    var species_id=$('#Speciesname').val();
var breed_id=$('#BreedName').val();
var age=$('#age').val();

this.getlistApi1="/reports/monthly_report/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;


var daylist = getDaysArray(new Date(from_date),new Date(to_date));
(await this.commonService.getApi(this.getlistApi1)).subscribe(
      (res) => {  
 
        this.opening_bal= (typeof res.data !== 'undefined' && res.data.length > 0)?res.data[0].opening_count:0; 
        let x=0; 
  let j=0; 
  let y=0;
  let closing_tot=0;
  let getData_count=[];
 
  for(x=0;x<daylist.length;x++){
    for(j=0;j<res.data.length;j++){
      var arr=this.arrayColumn(getData_count, 'date');
      if(arr.includes(daylist[x])==false){
        if(res.data[j].date==daylist[x]){
          
          y=j+1;
          getData_count.push(res.data[j]);
          closing_tot=res.data[j].daily_closing_balance+closing_tot;
          //console.log('true',closing_tot);
        }else{
          var arr1=this.arrayColumn(getData_count, 'date');
         
          if(arr1.includes(res.data[j].date)==false ){
            //console.log("first",y);
            closing_tot=((y==0)?this.opening_bal:res.data[y-1].daily_closing_balance)+closing_tot;
            //console.log('true_else',closing_tot);
            getData_count.push({
              "date": daylist[x],
              "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "additon_count": 0,
              "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "death_count": 0,
              "deletion_count": 0,
              "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
            });
            
          }else{
            if(y==res.data.length){
              closing_tot=(y==0)?this.opening_bal:res.data[y-1].daily_closing_balance+closing_tot;
              //console.log("first2",closing_tot);
              getData_count.push({
                "date": daylist[x],
                "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                "additon_count": 0,
                "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                "death_count": 0,
                "deletion_count": 0,
                "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
              });
              
            }
          }

        }
        
      }
     // console.log(closing_tot);
    }
  }
  //var after_forloop = ()=>{
    console.log(closing_tot)
    console.log(res.data.length)
    this.dict[ind]['ani_days']= closing_tot; 
          if(typeof res.data !== 'undefined' && res.data.length==0){
      
              this.dict[ind]['ani_days']=this.dict[ind-1]['ani_days'];
            
                 }
          if(ind==0){
            this.dict[ind]['ani_cumulative_animal_days']= closing_tot;  
          }else {
            this.dict[ind]['ani_cumulative_animal_days']=this.dict[ind-1]['ani_cumulative_animal_days']+closing_tot;
  
          }
  /*}
  setTimeout(() => {
    after_forloop();
  }, 3000);*/

        
         }) ;

         return false;
         //return closing_total;
  }

  endOfMonth(date)
  {
    date= new Date(date) ; 
  return this.end_date_format(new Date(date.getFullYear(), date.getMonth() + 1, 0));
 
  }

  end_date_format(dateObject) {
    var d = dateObject;
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1 ;
    var month1 ;
    if (day < 10) {
        day1 = "0" + day;
    }else{
       day1 = day;
    }
    if (month < 10) {
        month1 = "0" + month;
    }else{
       month1 =  month;
    }
    var date = year + "-" + month1 + "-" + day1;
  
    return date;
  };

  exportdata(){

    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'stock_export_' + new Date().getTime() );
  
  /* save to file */
  XLSX.writeFile(wb, 'stock_export_' + new Date().getTime()+'.xlsx');
    //this.exportAsExcelFile(this.getExportData, 'data');
  }
 
}

